'use client';

import SectionHeader from '@/app/(website)/components/SectionHeader';
import CheckFat from '@/assets/icons/CheckFat.svg';
import {Body} from '@/components/body';
import {useEffect, useRef, useState} from 'react';

const reasons = [
  'Per arrivare più rapidamente al punto normativo e procedurale rilevante.',
  'Per costruire una prima bozza utile senza partire ogni volta da zero.',
  'Per leggere più velocemente pratiche, allegati e documentazione tecnica dispersiva.',
  'Per supportare collaboratori e junior con una base di lavoro più ordinata e guidata.',
  'Per gestire casi che toccano più ambiti insieme: edilizia, energia, strutture, paesaggio, sicurezza, incentivi.',
  'Per mantenere il controllo professionale: la valutazione finale resta sempre al tecnico.',
];

export default function WhyArchEng() {
  const [isVisible, setIsVisible] = useState(false);
  const listRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {threshold: 0.2},
    );

    if (listRef.current) {
      observer.observe(listRef.current);
    }

    return () => {
      if (listRef.current) {
        observer.unobserve(listRef.current);
      }
    };
  }, []);

  return (
    <div id="pricing" className="w-full md:px-8 py-16">
      <div className="flex flex-col items-center justify-center md:rounded-2xl px-4 py-16 gap-3">
        <SectionHeader
          badgeText="Perché sceglierlo"
          title={
            <>
              Perché uno{' '}
              <span className="rounded-[2rem] rounded-br-[8px] py-0 px-2 md:px-4 bg-secondary text-primary">
                studio tecnico
              </span>{' '}
              lo usa davvero
            </>
          }
          subtitle=""
        />
        <ul
          ref={listRef}
          className="flex flex-col gap-5 max-w-[56.625rem] w-full"
        >
          {reasons.map((reason, index) => (
            <li
              key={index}
              className={`flex items-start gap-4 transition-all duration-700 ease-in-out transform ${
                isVisible
                  ? 'opacity-100 translate-y-0'
                  : 'opacity-0 translate-y-8'
              }`}
              style={{transitionDelay: `${index * 120}ms`}}
            >
              <span className="mt-1 shrink-0 text-secondary">
                <CheckFat width={24} height={24} />
              </span>
              <Body variant="large">{reason}</Body>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
